export default {
  http: {
    timeout: {
      title: 'Operation timed out.',
      body: 'Looks like the server is taking to long to respond.',
    },
    network: {
      title: 'Unable to connect to the serveur.',
      body: 'Please check your connection then retry.',
    },
    invalid_token: 'Invalid or expired connection link.',
    logout: "You've been logged out.",
    '400': 'You should change your request.',
    '401': 'You need to login to perform this action.',
    '402': 'You need an active subscription to perform this action.',
    '422': 'You need can not perform  this action now.',
    '403': 'You are not allowed to perform this action.',
    '404': {
      title: 'Sorry, page not found!',
      body: 'We couldn’t find the page you’re looking for. Perhaps you’ve mistyped the URL? Be sure to check your spelling.',
    },
    '500': {
      title: 'Internal Server Error!',
      body: 'There was an error, please try again later.',
    },
  },
  oauth: {
    generic: 'An error happened during authentication',
  },
  generic: 'An error happened.',
}
